import { Navigate, useLocation } from 'react-router-dom';
import { SAVED_VIEW_PARAM } from '@bms2/shared';

/**
 * 🔒 The old queue addresses (decision 2880): each opens its list on the built-in view
 * that replaced it, so a kept link still lands. The five addresses and the list and
 * view each one names are one table, which the route table and its test both read.
 */
export const SAVED_VIEW_REDIRECTS = [
  { from: 'leads/held', list: '/leads', view: 'held' },
  { from: 'leads/unrouted', list: '/leads', view: 'unrouted' },
  { from: 'companies/customers', list: '/companies', view: 'customers' },
  { from: 'companies/vendors', list: '/companies', view: 'vendors' },
  { from: 'companies/manufacturers', list: '/companies', view: 'manufacturers' },
] as const;

/** Opens the list on the view, keeping every other query parameter the old address carried, such as a search term (T2191). */
export function SavedViewRedirect({ list, view }: { list: string; view: string }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set(SAVED_VIEW_PARAM, view);
  return <Navigate to={`${list}?${params.toString()}`} replace />;
}
